import { render, staticRenderFns } from "./CartPanel.vue?vue&type=template&id=54e0a2c4&scoped=true&"
import script from "./CartPanel.vue?vue&type=script&lang=js&"
export * from "./CartPanel.vue?vue&type=script&lang=js&"
import style0 from "./CartPanel.vue?vue&type=style&index=0&id=54e0a2c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0a2c4",
  null
  
)

export default component.exports